<script>
import ExpandableCard from "@/components/ExpandableCard.vue";
import PaginatedList from "@/components/PaginatedList.vue";
import CommonBottomBar from "@/components/CommonBottomBar.vue";

export default {
  name: "homePage",
  // eslint-disable-next-line vue/no-unused-components
  components: {CommonBottomBar, PaginatedList, ExpandableCard},
  data() {
    return {
      // imgSrc: require('@/assets/images/home/PP-graphics-home-img-02.png'),
      // isImageLoaded: false,
      activeName: 'second',
      dialogVisible: false,
      currentVideoId: '',
      carouselHeight: '1080px',
      currentActive: 0,
      imageHeights: {},
      homeCarousel:[
        {imgUrl: require('@/assets/images/about/PP-graphics-home-imgm-04.png'), loaded: false},
        {imgUrl: require('@/assets/images/home/banner2-1920-DK-2.jpg'), loaded: false},
        {imgUrl: require('@/assets/images/home/banner2-1920-759-2.jpg'), loaded: false},
        {imgUrl: require('@/assets/images/home/360.jpg'), loaded: false},
        {imgUrl: require('@/assets/images/home/MX.jpg'), loaded: false},
        {imgUrl: require('@/assets/images/home/sandbox.jpg'), loaded: false},
        {imgUrl: require('@/assets/images/home/TH.jpg'), loaded: false},
      ]
    }
  },
  created() {
  },
  mounted() {
    this.loadImage(this.currentActive)
  },
  computed:{
    featuredPromo(){
      return [
        {
          arrange:true,
          title:this.$t('home.top-fun'),
          coin:'325',
          hasDollar:true,
          smallText:this.$t('home.top-fun-smallText'),
          saveImg:require('@/assets/images/home/Group 1078.png'),
          image:require('@/assets/images/home/Group 1063.png'),
          click: () =>{
            this.$router.push('/About');
          }
        },{
          arrange:false,
          title:this.$t('home.top-excursion'),
          coin:this.$t('home.top-excursion-20'),
          hasDollar:false,
          endText:this.$t('home.top-excursion-endText'),
          image:require('@/assets/images/home/ico_0002_1.png'),
          click: () =>{
            this.$router.push('/About');
          }
        },{
          arrange:true,
          title:this.$t('home.top-cash'),
          coin:'95',
          hasDollar:true,
          saveImg:require('@/assets/images/home/Group 1079.png'),
          image:require('@/assets/images/home/Group 1077.png'),
          click: () =>{
            this.$router.push('/About');
          }
        },
      ]
    },
    registrationCards(){
      return [
        { title: this.$t('home.registration1'), videoId: 'https://www.youtube.com/embed/GdtX5lIh4fA?si=wpkaSabUwb-wabqV' },
        { title: this.$t('home.registration2'), videoId: 'https://www.youtube.com/embed/XiDsb8q1w_E?si=fD3jPe_x4Ir4z0wZ' },
        { title: this.$t('home.registration3'), videoId: 'https://www.youtube.com/embed/GdLsBkCVZ_M?si=v2tn1TPISzbqRag-' }
      ]
    },
    redemptionCards(){
      return[
        { title: this.$t('home.redemption1'), videoId: 'https://www.youtube.com/embed/OVKXEzAElT8?si=G9CsO_IVuR2JRrdv' },
        { title: this.$t('home.redemption2'), videoId: 'https://www.youtube.com/embed/hzNOamwVHsw?si=0gAhtmQzTSF04v5f' },
        { title: this.$t('home.redemption3'), videoId: 'https://www.youtube.com/embed/A-wl_9fHAgg?si=fQmzyt4ox4WguVqV' },
        { title: this.$t('home.redemption4'), videoId: 'https://www.youtube.com/embed/lmAoZOdbFG4?si=Kq5XqWLblJF4KwO0' },
        { title: this.$t('home.redemption5'), videoId: 'https://www.youtube.com/embed/QK9BHSpqSXE?si=WIJ6nrjjZ_M9laco' }
      ]
    },
    monkeyCoin(){
      return [
        {
          image:require('@/assets/images/home/reward-Asset 63.png'),
          text:this.$t('home.monkeyCoin-Excursion')
        },
        {
          image:require('@/assets/images/home/reward-Asset 62.png'),
          text:this.$t('home.monkeyCoin-Fun')
        },
        {
          image:require('@/assets/images/home/reward-Asset 61.png'),
          text:this.$t('home.monkeyCoin-Premiums')
        },
        {
          image:require('@/assets/images/home/reward-Asset 60.png'),
          text:this.$t('home.monkeyCoin-Cash')
        },
        {
          image:require('@/assets/images/home/reward-Asset 59.png'),
          text:this.$t('home.monkeyCoin-Gift')
        },
        {
          image:require('@/assets/images/home/reward-Asset 58.png'),
          text:this.$t('home.monkeyCoin-Complimentary')
        }
      ]
    }
  },
  methods: {
    handleCarouselChange(toIndex){
      this.currentActive = toIndex
      this.loadImage(toIndex)
    },
    loadImage(index) {
      if (!this.homeCarousel[index].loaded) {
        this.$set(this.homeCarousel[index], 'loaded', true)
      }
    },
    scrollToTabNavigation(offset = 80){
      const el =document.querySelector('.tab-navigation')
      if(!el) return
      const header = document.querySelector('.header-container')
      offset = header.offsetHeight * 2
      const rect = el.getBoundingClientRect()
      console.log(rect)
      const scrollTop = document.documentElement.scrollTop
      const targetY = scrollTop + rect.top - offset
      window.scrollTo({
        top: targetY,
        behavior: 'smooth',
      });
    },
    openVideo(videoId){
      this.currentVideoId = videoId
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.currentVideoId = ''
    }
  }
}
</script>

<template>
  <div class="home-container">
    <el-carousel ref="carousel" indicator-position="outside" @change="handleCarouselChange" :loop="true">
      <el-carousel-item v-for="(item, index) in homeCarousel" :key="index">
        <img v-if="item.loaded" class="mw-100 fade-in-image vertical-middle" :src="item.imgUrl" alt="">
        <div v-else class="image-loading">
          <i class="el-icon-loading loading-icon"></i>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="privilege-content">
      <div class="p-m-d" style="display: flex; align-items: flex-start; column-gap: 200px">
        <div class="content-left">
          <h1 class="left-h">{{$t('home.aboutPPTitle')}}</h1>
          <p class="left-p">
            {{$t('home.aboutPPIntro')}}
          </p>
          <div class="qr-box" style="">
            <div style="width: 152px">
              <img src="@/assets/images/home/N_appIcon.webp" class="mw-100 vertical-middle" style="width: 100%" alt="">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 119px">
              <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
              <img style="margin-top: 5%;" src="@/assets/images/home/NEW_PP_Asset 350@3x.png" class="mw-100" alt="">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;  width: 119px">
              <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
              <img style="margin-top: 5%;" src="@/assets/images/home/NEW_PP_Asset 351@3x.png" class="mw-100" alt="">
            </div>
          </div>
        </div>
        <div class="content-right">
          <ul>
            <li class="r-tip"><img style="display: none" src="@/assets/images/icon/Ellipse 1.png" alt=""> {{$t('home.aboutPPSmallText1')}}</li>
            <li class="r-tip"><img style="display: none" src="@/assets/images/icon/Ellipse 1.png" alt=""> {{$t('home.aboutPPSmallText2')}}</li>
            <li class="r-tip"><img style="display: none" src="@/assets/images/icon/Ellipse 1.png" alt=""> <span v-html="$t('home.aboutPPSmallText3')"></span></li>
          </ul>
          <div class="home-video-box">
            <iframe class="video" width="100%" height="315" src="https://www.youtube.com/embed/CuystMn5tfg?si=tP5NVQuIhwX4JN_X" title="YouTube video player"
                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>

    </div>
    <div class="monkey-coin-rewards-section">
      <h1 class="text-center">{{$t('home.monkeyCoinTitle')}}</h1>
      <div class="rewards-box">
        <div class="text-center" v-for="(item,index) in monkeyCoin" :key="index">
          <div class="reward-img">
            <img :src="item.image" alt="">
          </div>
          <p class="mt-3" v-html="item.text"></p>
        </div>
      </div>
      <h1>{{$t('home.topUpCoinTitle')}}</h1>
      <img class="mw-100 rewards-coin" src="@/assets/images/home/coin-Asset 65.png" alt="">
    </div>
<!--    <div class="eli-content container">-->
<!--      <h1 >Eligibility</h1>-->
<!--      <p>Find out how you could be a Privilege Program member and enjoy all the benefits and each offers.</p>-->
<!--      <div>-->
<!--        <img src="@/assets/images/home/Asset 54@2x.png" class="mw-100" alt="">-->
<!--      </div>-->
<!--      <div class="member-picture">-->
<!--        <img src="@/assets/images/home/Asset 53@2x.png" class="mw-100" alt="">-->
<!--      </div>-->
<!--    </div>-->
    <div>
      <img style="vertical-align: middle; width: 100%" src="@/assets/images/partner/top-Asset 17.png" alt="">
    </div>
    <div class="featured-promo d-xs-block d-lg-none">
      <div class="container featured-promo-content">
        <h1>{{$t('home.topPicks')}}</h1>
        <div class="promo-items" v-for="(item, index) in featuredPromo" :key="index" :class="{ 'reverse-order': !item.arrange }">
          <div class="left-content">
            <h2>{{item.title}}</h2>
            <img v-if="item.saveImg" class="mw-100 save-img" :src="item.saveImg" alt="">
            <div style="display: flex; flex-direction: row; align-items: center; line-height: 1.3">
<!--              <p class="promo-text">{{item.text}}</p>-->
              <div class="promo-coin">
                <span v-if="item.hasDollar" style="margin-right: 1rem"><img src="@/assets/images/icon/Asset 66.png" alt=""></span>
                <span class="coin">{{item.coin}}</span>
                <span v-if="item.endText">{{item.endText}}</span>
              </div>
            </div>
            <p class="promo-sm-text" v-if="item.smallText">{{item.smallText}}</p>
            <el-button class="more" type="text" @click="item.click()">{{$t('home.learnMore')}}</el-button>
          </div>
          <div class="right-content">
            <img :src="item.image" alt="" class="mw-100">
          </div>
        </div>
      </div>
      <img style="width: 100%" src="@/assets/images/home/PP-graphics-home-img.png" alt="">
    </div>
    <div class="mobile-featured-promo d-xs-none d-lg-flex">
      <h1>{{$t('home.topPicks')}}</h1>
      <div class="mobile-promo">
        <div class="items" v-for="(item, index) in featuredPromo" :key="index">
          <h2>{{item.title}}</h2>
          <img style="margin: 5% 0 15%" :src="item.image" alt="" class="mw-100 m-promo-image">
          <img v-if="item.saveImg" class="mw-100 save-img" :src="item.saveImg" alt="">
          <p class="mobile-promo-text">{{item.text}}</p>
          <div class="m-promo-coin">
            <span v-if="item.hasDollar" style="margin-right: 1rem"><img src="@/assets/images/icon/Asset 66.png" alt=""></span>
            <span class="m-coin" :style="{fontSize: item.endText ? '53px' : '75px'}">{{item.coin}}</span>
            <span style="font-size: 36px" v-if="item.endText">{{item.endText}}</span>
          </div>
          <p class="promo-sm-text" v-if="item.smallText">{{item.smallText}}</p>

          <el-button class="m-more" type="primary" round @click="item.click()">{{$t('home.learnMore')}}</el-button>
        </div>
      </div>
      <img style="width: 100%" src="@/assets/images/home/PP-graphics-home-img.png" alt="">
    </div>
    <div class="member-registration">
      <div class="container">
        <div class="registration-wrap">
          <h1>{{$t('home.member-Registration')}}</h1>
          <p>{{$t('home.member-Registration-intro')}}</p>
          <img style="align-self: end; width: 80%" class="d-xs-none d-lg-block" src="@/assets/images/home/mo-Asset 56-8.png" alt="">
          <div class="reg-qrBox">
            <span style="width: 131px">
              <img src="@/assets/images/home/N_appIcon.webp" class="mw-100" style="width: 100%" alt="">
            </span>
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 120px">
              <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
              <img style="margin-top: 5%" src="@/assets/images/home/NEW_PP_Asset 350@3x.png" class="mw-100" alt="">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 120px">
              <img src="@/assets/images/home/NEW_PP_Asset 348@3x.png" class="mw-100" alt="">
              <img style="margin-top: 5%" src="@/assets/images/home/NEW_PP_Asset 351@3x.png" class="mw-100" alt="">
            </div>
          </div>
          <div class="reg-video-box">
            <div class="d-flex" style="align-items: center; font-weight: bold">
              <img src="@/assets/images/home/Asset 409@2x.webp" style="width: 3.5%; margin-right: 1.5%" alt="">
              {{$t('home.video-Tutorial')}}
            </div>
            <div class="re" style="margin-top: 3%">
              <h5>{{$t('home.video-registration')}}</h5>
              <div class="redemption-row">
                <div class="card" v-for="(card, index) in registrationCards" :key="`reg-${index}`" @click="openVideo(card.videoId)">
                  <img src="@/assets/images/home/Asset 411@2x.webp" class="mw-100" alt="">
                  <span v-html="card.title.replace(/\n/g, '<br>')"></span>
                </div>
              </div>
            </div>
            <el-divider style=""/>
            <div class="re">
              <h5>{{$t('home.video-redemption')}}</h5>
              <div class="redemption-row">
                <div v-for="(card, index) in redemptionCards" :key="`red-${index}`" class="card" @click="openVideo(card.videoId)">
                  <img src="@/assets/images/home/Asset 411@2x.webp" class="mw-100" :alt="card.title" />
                  <span v-html="card.title.replace(/\n/g, '<br>')"></span>
                </div>
              </div>
            </div>
            <el-divider/>
          </div>
        </div>
      </div>
    </div>
    <CommonBottomBar/>
    <!-- YouTube Video Dialog -->
    <el-dialog
        :visible.sync="dialogVisible"
        @close="closeDialog"
        width="800"
        :show-close="false"
        :close-on-click-modal="false"
    >
      <div v-if="currentVideoId" class="video-container" style="height: 550px">
        <iframe
            :src="currentVideoId"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
            height="100%"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{$t('common.close')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.home-container{
  width: 100%;
  .big-image{
    min-height: 70vh;
    //display: flex;
    //align-items: center;
    //justify-content: center;
    overflow: hidden;
    position: relative;
    @include media-max(sm){
      min-height: 30vh;
    }
  }
  /* 图片淡入动画 */
  .fade-in-image{
    opacity: 0;
    animation: fadeIn 0.5s ease-in forwards;
  }
  /* 加载状态 */
  .image-loading{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #009344;
  }
  .loading-icon{
    font-size: 48px;
    animation: rotate 2s linear infinite;
  }
  ::v-deep .el-carousel__container{
    height: 1080px;
  }
  .privilege-content{
    margin-top: 132px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    //column-gap: 200px;
    //align-items: flex-start;
    //justify-content: space-between;
    //align-items: center;
    //@media (max-width: 991px) {
    //  flex-direction: column;
    //  align-items: normal;
    //}
    .content-left{
      flex: 1;
      //text-align: center;
      display: flex;
      flex-direction: column;
      //justify-content: center;
      //align-items: center;

      margin-left: 251px;
      //.left-logo{
      //  width: 325px;
      //}
      .left-h{
        font-size: 45px;
        //line-height: 104px;
        color: #158800;
      }
      .left-p{
        margin-top: 30px;
        font-size: 20px;
        line-height: 40px;
        color: #5A2A00;
      }
    }
    .content-right{
      flex: 1;
      .r-tip{
        background: #fff9cc;
        border-radius: 33px 0 0 33px;
        font-size: 25px;
        margin-top: 32px;
        line-height: 50px;
        padding: 5px 0 5px 50px;

        &:first-child{
          margin-top: 0;
        }
        ::v-deep .highlight-count {
          font-size: 41px;
          color: #1AA344;
          font-weight: bold;
        }
      }
      .home-video-box{
        margin-top: 5%;
        padding-right: 5%;
        .video{
          height: 400px;
        }
      }
    }
    .qr-box{
      margin-top: 85px;
      display: flex;
      //justify-content: center;
      column-gap: 3%;
      align-items: flex-start;
      //margin-left: 251px;
    }
  }
  .monkey-coin-rewards-section{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 400px;
    margin-bottom: 282px;
    h1{
      font-size: 45px;
      line-height: 104px;
      color: #158800;
    }
    .rewards-box{
      margin: 130px 0 200px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      column-gap: 50px;
      flex-wrap: wrap;
      justify-content: center;
      .reward-img{
        min-height: 150px;
      }
      p{
        color: #5A2A00;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .eli-content{
    margin-top: 306px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h1{
      color: #158800;
      font: normal normal 800 45px/104px Nunito;
    }
    p{
      margin-top: 3.5%;
      margin-bottom: 7%;
      font: normal normal normal 20px/32px Helvetica Neue;
    }
    .member-picture{
      margin-top: 7%;
    }
  }
  .featured-promo{
    position: relative;
    padding-top: 82px;
    background: #fff9df;
    .featured-promo-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      row-gap: 96px;
      h1{
        color: #158800;
        font-size: 45px;
        margin-bottom: 5%;
      }
      .promo-items{
        width: 90%;
        display: flex;
        align-items: center;
        &.reverse-order {
          flex-direction: row-reverse;
        }
        .left-content{
          flex: 1;
          padding-left: 4%;
          h2{
            color: #158800;
            font-size: 35px;
          }
          .promo-text{
            font-size: 20px;
            margin-right: 2%;
          }
          .coin{
            font-size: 95px;
            font-weight: bold;
          }
          span{
            font-size: 65px;
          }
          .more{
            background: transparent;
            border: none;
            font-size: 20px;
            margin-top: 5%;
            color: #5A2A00;
            text-decoration: underline;
          }
          .promo-sm-text{
            font-size: 15px;
            color: #838383;
            margin-left: 22%;
            margin-top: -3%;
          }
          .save-img{
            margin-top: 8%;
          }
        }
        .right-content{
          flex: 1;
        }
      }
    }
  }
  .mobile-featured-promo{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff9df;
    h1{
      color: #158800;
    }
    .mobile-promo{
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 20px;
      .items{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 35px;

        h2{
          font-size: 27px;
          color: #158800;
          margin-bottom: 16px;
        }
        .save-img{
          align-self: flex-start;
          margin-left: 10%;
        }
        .mobile-promo-text{
          font-size: 24px;
        }
        .m-promo-coin{
          img{
            width: 50px;
          }
          .m-coin{
            font-size: 75px;
            font-weight: bold;
            line-height: 1.3;
          }
        }
        .promo-sm-text{
          font-size: 15px;
          color: #838383;
          //margin-left: 22%;
          margin-top: -3%;
        }
        .m-more{
          font-size: 19px;
          border-color: transparent;
          text-decoration: underline;
          background: transparent;
          //padding: 12px 20%;
          color: #5A2A00;
        }
      }
    }
  }
  .member-registration{
    margin-top: 9.5%;
    margin-bottom: 8%;
    background: transparent url('@/assets/images/home/Asset 410@2x.png') no-repeat center;
    background-size: 100%;
    //background-size: 100% 100%;
    .registration-wrap{
      max-width: 60%;
      h1{
        font-size: 35px;
        color: #158800;
      }
      p{
        font-size: 20px;
        line-height: 32px;
        margin-top: 4%;
      }
      .reg-qrBox{
        display: flex;
        //justify-content: center;
        align-items: flex-start;
        column-gap: 38px;
        margin-top: 8%;
        img{
          width: 90%;
        }
      }
      .reg-video-box{
        margin-top: 10%;
        font-size: 20px;
        line-height: 32px;
        .re{
          padding-left: 5%;
          h5{
            font-size: 20px;
            line-height: 32px;
            color: #158800;
            margin-bottom: 2%;
          }
          .registration-grid{
            display: grid;
            grid-template-columns: repeat(2, 230px);
            gap: 31px 28px;
            justify-content: start;
          }
          .redemption-row{
            display: flex;
            gap: 28px;
            align-items: center;
            flex-wrap: wrap;
          }
          .card{
            position: relative;
            width: 230px;
            cursor: pointer;
            span{
              position: absolute;
              left: 30%;
              top: 50%;
              transform: translateY(-60%);
              font-size: 15px;
              line-height: 18px;
              color: #5A2A00;
            }

          }
        }
        .el-divider--horizontal{
          margin: 64px 0;
        }
      }
    }
  }
  .tab-navigation{
    ::v-deep(.tabs){
      .el-tabs__header{
        display: flex;
        justify-content: center;
      }
      .el-tabs__nav-wrap::after{
        height: 0 !important;
      }
      .el-tabs__active-bar{
        background: #5A2A00;
        height: 3px;
      }
      .el-tabs__nav{
        display: flex;
        align-items: center;
      }
      .el-tabs__item{
        height: auto;
        //height: 83px;
        line-height: 36px;
        padding-bottom: 23px;
        font-size: 25px;
        font-weight: bold;
        color: #5A2A00;
      }
      .el-tab-pane{
        background: #fff0d3;
        padding-bottom: 250px;
      }
    }
    .tabs-detail-box{
      padding: 65px 10px;
      .top-intro{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .intro-text{
          display: flex;
          flex-direction: column;
          margin-left: 6.5%;
          div{
            font-size: 55px;
            line-height: 72px;
            font-weight: bold;
            color: #158800;
            .dollar{
              font-size: 45px;
            }
            .special{
              font-size: 65px;
              .dollar{
                font-size: 94px;
              }
            }
          }
          p{
            font-size: 20px;
            margin-top: 3.2%;
          }

        }
      }
    }
    .product-content-flex{
      margin-top: 150px;
      padding: 0 20px 20px;
      display: flex;
      row-gap: 45px;
      flex-direction: column;
    }
    .product-content-grid{
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 40px;
      row-gap: 55px;
      padding: 20px 0;
      .premiums-item{
        .name{
          font-size: 30px;
          line-height: 30px;
          color: #393939;
          text-align: center;
        }
        .price{
          margin-top: 20px;
          display: flex;
          align-items: center;
          span{
            margin-left: 10px;
            font-size: 30px;
            line-height: 25px;
          }
        }
      }
    }
    .notice-text{
      margin-top: 229px;
      color: #158800;
      font-size: 25px;
      line-height: 32px;
      text-align: center;
    }
  }
  @include media-max(xxl){
    ::v-deep .el-carousel__container{
      height: 765px;
    }
    .privilege-content{
      .p-m-d{
        column-gap: 100px !important;
        .content-left{
          margin-left: 100px;
        }
      }
      .content-right{
        .home-video-box{
          margin-top: 5%;
          padding-right: 5%;
          .video{
            height: 350px;
          }
        }
      }
    }
    .item{
      .span{
        width: 32%;
      }
    }
    .member-registration{
      .registration-wrap{
        padding-left: 30px;
      }
    }
  }
  @include media-max(xl){
    ::v-deep .el-carousel__container{
      height: 660px;
    }
    .item{
      .span{
        width: 35%;
      }
    }
  }
  @include media-max(lg){
    margin-top: 108px;
    ::v-deep .el-carousel__container{
      height: 530px;
    }
    .privilege-content{
      margin-top: 100px !important;

      .p-m-d{
        flex-direction: column;
        justify-content: center;
        align-items: center !important;
        .content-left{
          margin-left: 0;
          text-align: center;
          padding: 0 55px;
        }
        .content-right{
          margin-top: 50px;
          .r-tip{
            display: flex;
            align-items: center;
            border-radius: 0;
            background: transparent;
            padding: 0;
            font-size: 20px;
            img{
              display: block !important;
              margin-right: 5px;
            }
            ::v-deep .highlight-count {
              font-size: 25px;
            }
          }
          .home-video-box{
            padding-right: 0;
            .video{
              height: 300px;
            }
          }
        }

      }
      .qr-box{
        margin-left: 0;
        justify-content: center;
      }
    }
    .monkey-coin-rewards-section{
      .rewards-box{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 37px;
      }
    }
    .featured-promo{
      padding-top: 29px;
    }
    .member-registration{
      background-image: none;
      .registration-wrap{
        max-width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        p{
          padding: 0 10%;
          text-align: center;
        }
        .reg-qrBox{
          margin-top: 0;
          column-gap: 2%;
        }
        .reg-video-box{
          margin-top: 61px;
          >div{
            font-size: 25px;
            justify-content: center;
          }
          .re{
            padding-left: 0;
            h5{
              font-size: 25px;
              text-align: center;
            }
            .redemption-row{
              //padding: 0 3%;
              margin-top: 5%;
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 15px;
            }
            .card{
              width: 210px;
              span{
                position: absolute;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    ::v-deep(.el-dialog){
      width: 90% !important;
    }
    .video-container{
      height: 40vh !important;
    }
    .tab-navigation{
      padding-top: 47px;
      background:#feefd3;
      ::v-deep(.tabs){
        .el-tabs__item{
          line-height: 25px;
          padding-bottom: 20px;
          font-size: 20px;
        }
      }
      .tabs-detail-box{
        .top-intro{
          flex-direction: column-reverse;
          .intro-text{
            margin-left: 0;
            padding: 0 6.5%;
            text-align: center;
            >div{
              font-size: 30px;
              .dollar{
                font-size: 28px;
              }
              .special{
                font-size: 40px;
                .dollar{
                  font-size: 69px;
                }
              }
            }
          }
          .intro-image{
            margin-top: 10%;
          }
        }
      }
      .product-content-flex{
        margin-top: 0;
        padding: 0 44px;
        row-gap: 45px;
      }
      .product-content-grid{
        grid-template-columns: repeat(2, 1fr);
        column-gap: 15px;
        row-gap: 40px;
        padding: 20px 44px;
      }
      .notice-text{
        margin-top: 100px;
      }
    }
    //.responsive-carousel{
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    //  width: 100%;
    //  height: 100%;
    //  img {
    //    width: 100%;
    //    height: 100%;
    //    object-fit: cover;
    //  }
    //}
  }
  @include media-max(md){
    margin-top: 148px;
    ::v-deep .el-carousel__container{
      height: 375px;
    }
    .privilege-content{
      .p-m-d{
        .content-left{
          .left-p{
            font-size: 17px;
          }
        }
      }
      .qr-box{
        div{
          width: 20% !important;
        }
      }
    }
    .monkey-coin-rewards-section{
      margin-top: 100px;
      margin-bottom: 150px;
      h1{
        padding: 0 5%;
      }
      .rewards-box{
        margin: 28px 0 95px;
        .reward-img{
          min-height: 94px;
          img{
            height: 94px;
          }
        }
      }
      .rewards-coin{
        margin-top: 37px;
        width: 60%;
      }
    }
    .mobile-featured-promo{
      .mobile-promo{
        .items{
          h2{
            font-size: 20px;
            color: #158800;
          }
          .save-img{
            width: 50%;
          }
          .mobile-promo-text{
            font-size: 17px;
          }
          .m-promo-image{
            width: 263px;
          }
          .m-promo-coin{
            img{
              //width: 50px;
            }
            .m-coin{
              //font-size: 75px;
              //font-weight: bold;
            }
          }
          .m-more{
            font-size: 15px;
          }
        }
      }
    }
    .member-registration{
      .registration-wrap{
        h1{
          font-size: 23px !important;
        }
        p{
          font-size: 12px;
        }
        .reg-qrBox{
          img{
            width: 90%;
          }
        }
        .reg-video-box{
          margin-top: 61px;
          padding: 0 30px;
          >div{
            font-size: 20px;
            justify-content: center;
          }
          .re{
            padding-left: 0;
            h5{
              font-size: 20px;
            }
            .card{
              width: 100%;
              span{
                position: absolute;
                font-size: 15px;
              }
            }
          }
        }
      }
    }
    .tab-navigation{
      ::v-deep(.tabs){
        .el-tabs__item{
          padding-bottom: 18px;
          font-size: 17px;
        }
      }
      .tabs-detail-box{
        .top-intro{
          .intro-text{
            text-align: center;
            >div{
              font-size: 23px;
              line-height: 30px;
              .dollar{
                font-size: 20px;
              }
              .special{
                font-size: 23px;
                .dollar{
                  font-size: 45px;
                }
              }
            }
            p{
              font-size: 12px;
            }
          }
          .intro-image{
            img{
              width: 231px;
            }
          }
        }
      }
      .product-content-grid{
        .premiums-item{
          .name{
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
      .notice-text{
        font-size: 17px;
        line-height: 20px;
      }
    }
  }
  @include media-max(sm){
    margin-top: 111px;
    ::v-deep .el-carousel__container{
      height: 250px;
    }
    .privilege-content{
      .p-m-d{
        .content-left{
          .left-p{
            font-size: 12px;
          }
        }
        .content-right{
          padding: 0 79px;
          .r-tip{
            align-items: flex-start;
            font-size: 16px;
            line-height: 1.5;
            img{
              display: block !important;
              margin-right: 5px;
              margin-top: 2%;
            }
            ::v-deep .highlight-count {
              font-size: 16px;
            }
          }
          .home-video-box{
            .video{
              height: 250px;
            }
          }
        }
      }
      .qr-box{
        div:first-child{
          width: 20%!important;
        }
        div{
          width: 16% !important;
        }
      }
    }
    .member-registration{
      .registration-wrap{
        .reg-qrBox{
          span{
            width: 100px !important;
          }
          div{
            width: 90px!important;
          }
        }
        .reg-video-box{
          margin-top: 10%;
          font-size: 20px;
          line-height: 32px;
          .re{
            //padding-left: 5%;
            h5{
              font-size: 20px;
              line-height: 32px;
              color: #158800;
              margin-bottom: 2%;
            }
            .registration-grid{
              display: grid;
              grid-template-columns: repeat(2, 200px);
              gap: 31px 28px;
              justify-content: start;
            }
            .redemption-row{
              //display: flex;
              //gap: 28px;
              //align-items: center;
              //flex-wrap: wrap;
              display: grid;
              grid-template-columns: repeat(2, 1fr);
            }
            .card{
              position: relative;
              //width: 200px;
              cursor: pointer;
              span{
                position: absolute;
                left: 30%;
                top: 50%;
                transform: translateY(-60%);
                font-size: 11px;
                line-height: 18px;
                color: #5A2A00;
              }

            }
          }
          .el-divider--horizontal{
            margin: 64px 0;
          }
        }
      }
    }
  }
  @include media-max(ssm){
    ::v-deep .el-carousel__container{
      height: 225px;
    }
  }
}

/* 淡入动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 旋转动画 */
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

</style>